import { directive } from '../app';
import { FILE_UPLOAD, MESSAGES } from '../utilities';
import template from '@lei-website-client/views/form/file.html';

export default /* @ngInject */ function leiFormFile($timeout, AlertMessenger, LlmService) {
  function link($scope) {
    // Register properties
    $scope.attachments = { refFiles: [], authorFiles: [], authorForm: [], party: 'first' };
    $scope.fileUpload = FILE_UPLOAD;

    $scope.auth = true;
    $scope.needRef = false; // need reference files if events are being added/updated or it's a fund
    $scope.llmValidationError = null; // Store LLM validation error message
    $scope.llmValidationLoading = false; // Loading state for LLM validation
    $scope.llmValidationSuccess = false; // Success state for LLM validation

    function read(validate = true) {
      const filesToUpload = [...$scope.attachments.refFiles, ...$scope.attachments.authorForm];

      const fileErrors = [];
      if (validate && $scope.auth && !$scope.attachments.authorForm.length) {
        fileErrors.push({ severity: 'error', message: MESSAGES.authorizationForm.error });
      }

      if (validate && $scope.needRef && !$scope.attachments.refFiles.length) {
        fileErrors.push({ severity: 'error', message: MESSAGES.referenceFile.error });
      }

      return { filesToUpload, fileErrors };
    }

    function party() {
      return $scope.attachments.party;
    }

    function toggleAuth(value) {
      if (value == null) value = !$scope.auth;
      $scope.auth = value;
    }

    function setNeedRefFile(value) {
      $scope.needRef = value;
    }

    function getValidationData() {
      return {
        llmValidationError: $scope.llmValidationError,
        llmValidationSuccess: $scope.llmValidationSuccess,
        llmValidationData: $scope.llmValidationData
      };
    }

    // Register actions
    $scope.dragAttachments = () => {
      const total = read(false).filesToUpload.reduce((sum, b) => sum + b.size, 0);
      if (total > FILE_UPLOAD.max_file_size) {
        return AlertMessenger.alert(MESSAGES.maxAttachmentsSizeSingle.error);
      }
    };

    $scope.dragAuthorFiles = async () => {
      $scope.attachments.authorForm = $scope.attachments.authorFiles.slice(-1);
      $scope.dragAttachments();

      // Reset previous validation states
      $scope.llmValidationError = null;
      $scope.llmValidationSuccess = false;
      $scope.llmValidationLoading = false;

      // Perform LLM validation if authorization form is uploaded
      if (__ENABLE_LLM_EXTRACTORS__ && $scope.attachments.authorForm && $scope.attachments.authorForm.length > 0) {
        // Check if URL is localhost or lei3.dev.bloomberg.com
        const hostname = window.location.hostname;
        if (hostname !== 'localhost' && hostname !== 'lei3.dev.bloomberg.com') {
          return;
        }

        // 1. get legal name
        let legalName = '';
        try {
          if (typeof $scope.formData === 'function') {
            const formDataResult = $scope.formData('ENTITY', { showErrors: false });
            legalName = formDataResult?.payload?.['com.bloomberg.ds.LEISubmissionv2']?.data?.entity?.legalName;
          }
        } catch (e) {
          legalName = '';
        }

        let authFile = $scope.attachments.authorForm[0];
        if (!legalName || !authFile) return;

        try {
          // Start loading state
          $timeout(() => {
            $scope.llmValidationLoading = true;
          });

          const llmValidationResult = (await LlmService.validateAuthForm(legalName, authFile)).data;

          // Use $timeout to safely update scope
          $timeout(() => {
            $scope.llmValidationLoading = false;
            $scope.llmValidationData = llmValidationResult;

            if (llmValidationResult && llmValidationResult.validated === false) {
              const warnings = [];

              // Check if entity names match (case insensitive)
              if (llmValidationResult.entity_name && legalName) {
                const extractedName = llmValidationResult.entity_name.toLowerCase().trim();
                const formName = legalName.toLowerCase().trim();
                if (extractedName !== formName) {
                  warnings.push(
                    `Legal name mismatch: Form shows "${legalName}" but authorization document shows "${llmValidationResult.entity_name}"`
                  );
                }
              }

              // Check if signature is present
              if (!llmValidationResult.signature) {
                warnings.push('Signature is missing from the authorization document');
              }

              $scope.llmValidationError = warnings.length > 0 ? warnings : [llmValidationResult.reason];
              $scope.llmValidationSuccess = false;
            } else {
              $scope.llmValidationError = null;
              $scope.llmValidationSuccess = true;
            }
          });
        } catch (e) {
          $timeout(() => {
            $scope.llmValidationLoading = false;
            $scope.llmValidationError = null; // do not show validation error if LLM service is not available
          });
        }
      }
    };

    $scope.deleteAttachment = (attachments, target) => {
      for (let i = 0; i < attachments.length; i++) {
        if (attachments[i].name === target.name) {
          attachments.splice(i, 1);

          // Clear validation info when authorization file is removed
          if (attachments === $scope.attachments.authorForm) {
            $scope.llmValidationError = null;
            $scope.llmValidationSuccess = false;
            $scope.llmValidationLoading = false;
            $scope.llmValidationData = null;
          }

          break;
        }
      }
    };

    $timeout(() =>
      $scope.onLoad({
        read,
        party,
        toggleAuth,
        setNeedRefFile,
        getValidationData
      })
    );
  }

  return { restrict: 'E', scope: { onLoad: '<onload', formData: '<formdata' }, link, template };
}

directive('leiFormFile', leiFormFile);
